
import { mapActions, mapGetters } from 'vuex'
import axios from 'axios'
import reviewData from '@/data/reviews.json'
import productData from '@/data/products.json'
import optionsData from '@/data/options.json';
import { getABBucket } from "@/utils/abTest";
import { sessionInstances, DIPLOMA_TIER } from '@/utils/courseSchema'
import promoData from '@/data/promo.json'

export default {
    props: {
        page: {
            type: Object,
            default() {
                return {}
            }
        },
        classroom: {
            default: 'false',
            type: String,
        },
        bundle: {
            default: 'false',
            type: String,
        },
        text: {
            default: 'Book Course Now',
            type: String
        },
        product_id: {
            default: null,
            type: String
        }
    },
    data(){
        return{
            // isVisible:false
            // product: {},
            // priceData: {},
            reviews: reviewData,
            options: optionsData,
            daySessions: [],
            audioSelected: false,
            countdownVisible: false,
        }
    },
    // Self-fetch classroom sessions at build so hasCourseInstance is baked into
    // the static HTML (the store path didn't survive `nuxt generate`).
    async fetch() {
        const product = this.product
        const days = (product && product.classRoomCourse) ? product.classRoomCourse.days : null
        if (!days) { this.daySessions = []; return }
        try {
            const res = await axios.get(process.env.DATA_URL + '/classroom/days/' + days)
            this.daySessions = res.data || []
        } catch (e) {
            this.daySessions = []
        }
    },
    head() {
        return {
            script: [{ hid: 'course-schema', type: 'application/ld+json', json: this.structuredData }]
        }
    },
    computed:{
        ...mapGetters({
          slug : 'pages/getPage',

        }),
        // A bundle packages several products together; identified by the product flag.
        isBundle() {
          return !!(this.product && this.product.isBundle)
        },
        audioProductId() {
          return (this.product && this.product.audioProductId) || null
        },
        // Resolve a bundle's component product IDs -> hasPart Course entries.
        // Allow-list actual course types; downloads / extras / vouchers / extensions
        // aren't Courses and are skipped (e.g. the PDF lesson-plan packs).
        bundleParts() {
          const COURSE_TYPES = ['online course', 'combined course', 'classroom course']
          const ids = (this.product && this.product.bundleProducts) ? this.product.bundleProducts : []
          const out = []
          ids.forEach((id) => {
            const entry = productData.find((o) => o.id != null && o.id.toString() === id.toString())
            if (!entry) return
            if (!COURSE_TYPES.includes(entry.type)) return
            const page = entry.page || {}
            const uri = (page.en && page.en.uri) ? page.en.uri : null
            if (!uri) return
            out.push({
              '@type': 'Course',
              name: entry.name,
              url: 'https://www.tefl.org' + uri
            })
          })
          return out
        },
        courseInstances() {
          const workload = 'PT' + this.workload + 'H'
          const dur = this.duration[this.pid] || null
          let instances = []

          // const days = (this.product && this.product.classRoomCourse)
          //   ? this.product.classRoomCourse.days : null
          const sessions = this.daySessions || []

          // Combined courses keep a self-paced online component alongside the sessions
          if (this.mode === 'blended') {
            const comp = {
              '@type': 'CourseInstance',
              name: 'Online component (self-paced)',
              courseMode: 'online',
              courseWorkload: workload
            }
            if (dur) comp.duration = dur
            instances.push(comp)
          }

          // Scheduled sessions -> onsite Place / virtual VirtualLocation (split by the mapper)
          instances = instances.concat(
            sessionInstances(sessions, { url: this.url, perVenueCap: 3 })
          )

          // Pure self-paced online course (or a classroom course with no upcoming dates)
          if (instances.length === 0) {
            const single = { '@type': 'CourseInstance', courseMode: this.mode || 'online', courseWorkload: workload }
            if (dur) single.duration = dur
            instances.push(single)
          }

          return instances
        },

        priceValidUntil() {
          const c = promoData.activeCampaign
          return (c && c.endDate) ? c.endDate : null
        },
        // Page-level virtual variant. Only resolvable when this box is showing the
        // page's main product — if an explicit product_id prop is passed we can't
        // know its virtual sibling, so we skip it.
        virtualPid() {
            if (this.$props.product_id !== null) return null
            return this.$store.state.pages.page.virtualProductId || null
        },
        virtual_product() {
            const vid = this.virtualPid
            if (!vid) return {}
            const found = productData.find((o) => o.id.toString() === vid.toString())
            return found || {}
        },
        vpriceData() {
            if (this.virtual_product && Object.keys(this.virtual_product).length > 0) {
                return this.$options.filters.priceData(this.virtual_product)
            }
            return {}
        },
        // Headline the deeper of the two discounts when both variants exist
        headlinePriceData() {
            const base = this.priceData
            const virtual = this.vpriceData
            if (virtual && Object.keys(virtual).length > 0) {
                const basePct = this.$options.filters.discountPercentageFromLabel(base.pricesDiscounted) || 0
                const virtualPct = this.$options.filters.discountPercentageFromLabel(virtual.pricesDiscounted) || 0
                return virtualPct > basePct ? virtual : base
            }
            return base
        },
        hasBothVariants() {
            return this.vpriceData && Object.keys(this.vpriceData).length > 0
        },
        pid(){
            return this.$props.product_id === null ? this.$store.state.pages.page.productId : this.$props.product_id
        },
        rand(){
            return Math.floor(Math.random() * 100)
        },
        product(){
            return productData.find((o) => {
                return o.id.toString() === this.pid
            })
        },
        priceData(){
            return this.$options.filters.priceData(
                this.product,
            )
        },
        description(){
            const desc = this.$store.state.pages.page.seo.fullHead.child[1].attr.content
            const description = desc.join(' ')
            return description
        },
        url(){
            const uri = 'https://www.tefl.org'+this.$store.state.pages.page.uri
            return uri
        },
        price(){
          const price = this.$nuxt.$options.filters.priceFromLabelNumber(this.priceData.pricesDiscounted)
          return price
        },
        currency(){
          const currency = this.$nuxt.$options.filters.currencyCodeFromLabel()
          return currency
        },
        workload() {

          const workload = this.product.course.hours.toString()
          return workload
        },
        mode() {
          let mode;
          if (this.product.type === "combined course") {
            mode = "blended"
            return mode
          }
          if (this.product.type === "classroom course") {
            mode = "onsite"
            return mode
          }
          else {
            mode = "online"
            return mode
          }
        },
        educationalLevel() {
          let level;
          // have arrays of product ids and set level based can use this.pid for this otherwise product.id

          // beginner: [120-hr, 200-hr, 140-hr, 140-hr virtual, 220-hr, 220-hr virtual, 130-hr, 130-hr virtual, 150-hr, 150-hr virtual, 230-hr, 230-hr virtual, 20-hr classroom, 20-hr virtual, 30-hr classroom, 30-hr virtual ]
          const beginner = [25, 10204, 26, 10168, 10205, 10206, 19, 10174, 27, 10172, 10207, 10208, 1, 10166, 8, 10171, 10193,10194,10196,10195,10197,10198]
          // advanced: [neurodivers, oberved teaching practice, teaching english online, EAP, Exam prep , young learners, business English, online teaching practice]
          const advanced = [10203,10200, 10192, 10191, 10189, 10179, 105, 106, 10161]

          if (beginner.includes(this.pid)){
            level = 'beginner'
          }
          if (advanced.includes(this.pid)){
            level = 'advanced'
          }
          else {
            level = 'beginner'
          }
          return level
        },
        coursePrerequisites() {
          let prerequisites
          if (this.educationalLevel === 'beginner'){
            prerequisites = 'No prior experience or qualifications are required to take this course. The course is for both native and non-native speakers. However, you must speak English fluently.'
          }
          else if (this.educationalLevel === 'advanced') {
            prerequisites = 'It would be beneficial to have an initial TEFL qualification (e.g. 120-hr Premier Online TEFL Course) prior to taking this course.'
          }
          else {
            prerequisites = 'No prior experience or qualifications are required to take this course.The course is for both native and non-native speakers. However, you must speak English fluently.'
          }
          return prerequisites
        },
        pageModified() {
            const p = this.$store.state.pages.page || {}
            return p.modified || null   // use whatever WPGraphQL exposes
        },
        diplomaProduct() {
          const id = DIPLOMA_TIER[this.product && this.product.id]
          if (!id) return null
          return productData.find((o) => o.id != null && o.id.toString() === id.toString()) || null
        },
        offers() {
          const list = [{
            '@type': 'Offer',
            'category': 'Paid',
            'name': this.product.name,
            'price': this.price,
            'priceCurrency': this.currency,
            'priceValidUntil': this.priceValidUntil || undefined,
            'url': this.url,
            'availability': 'https://schema.org/InStock'
          }]
          const dip = this.diplomaProduct
          if (dip) {
            const dipPrice = this.$options.filters.priceData(dip)
            list.push({
              '@type': 'Offer',
              'category': 'Paid',
              'name': dip.name,
              'price': this.$nuxt.$options.filters.priceFromLabelNumber(dipPrice.pricesDiscounted),
              'priceCurrency': this.currency,
              'priceValidUntil': this.priceValidUntil || undefined,
              'url': this.url,
              'availability': 'https://schema.org/InStock'
            })
          }
          return list
        },
        inLanguage() {
          const page = (this.product && this.product.page) || {}
          const langs = []
          if (page.en) langs.push('en-GB')
          if (page.en_us) langs.push('en-US')
          return langs.length ? langs : 'en-GB'
        },
        duration() {
          return {
            25: "P0Y6M0D",
            10204: "",
            26: "P0Y6M0D",
            10168: "P0Y6M0D",
            10205: "P0Y7M0D",
            10206: "P0Y7M0D",
            19: "P0Y7M0D",
            10174: "P0Y7M0D",
            27: "P0Y7M0D",
            10172: "P0Y7M0D",
            10207: "P0Y7M0D",
            10208: "P0Y7M0D",
            1: "P0Y0M2D",
            10166: "P0Y0M2D",
            8: "P0Y0M3D",
            10171: "P0Y0M3D",
            10203:"P0Y1M0D",
            10200:"P0Y1M0D",
            10192: "P1Y0M0D",
            10191: "P0Y2M0D",
            10189: "P0Y2M0D",
            10179: "P0Y2M0D",
            105: "P0Y1M0D",
            106: "P0Y1M0D",
            10161: "P0Y0M3D",
            10193: "P0Y6M0D",
            10194: "P0Y7M0D",
            10196: "P0Y6M0D",
            10195: "P0Y7M0D",
            10197: "P0Y6M0D",
            10198: "P0Y7M0D",
          }
        },
        structuredData() {
            const data = {
                "@context": "https://schema.org/",
                "@type": "Course",
                "name": this.priceData.product.name,
                "@id": this.url,
                "description": this.description,

                "image": this.$store.state.pages.page.thumbnail,
                "inLanguage": this.inLanguage,

                "provider": { "@id": "https://www.tefl.org/#organization" },
                "courseCode": "TEFLORG"+this.priceData.product.id,
                "interactivityType": "active",
                "publisher": {
                    "@id": "https://www.tefl.org/#organization"
                },
                "offers": this.offers,
                "educationalCredentialAwarded": {
                  "@type": "EducationalOccupationalCredential",
                  "name": "Tefl Org Certificate",
                  "credentialCategory": "Certificate",
                  "url": "https://www.tefl.org/about-us/accreditation/",
                  "educationalLevel": this.educationalLevel
                },
                "audience": {
                  "@type": "Audience",
                  "audienceType": [
                    "People who are serious about teaching English as a foreign language.",
                    "Those who are interested in the opportunity to work in most countries in the world.",
                    "Professionals who want to re-educate themselves.",
                    "Students who are considering a gap year.",
                    "Anyone who would like a career teaching online."
                  ]
                },
                "about": "Teaching English as a Foreign Language",
                "timeRequired": "PT"+this.workload+"H",
                "learningResourceType": "Course",
                "coursePrerequisites": this.coursePrerequisites,
                "dateModified": this.pageModified || undefined,
            }

            // Bundles describe their component courses via hasPart and carry no
            // CourseInstance of their own (the parts hold their own scheduling on
            // their detail pages). Every other course carries its instance(s).
            if (this.isBundle) {
                if (this.bundleParts.length) data.hasPart = this.bundleParts
            } else {
                data.hasCourseInstance = this.courseInstances
            }

            return data
        },
        saleArray(){
          const FPCourses = optionsData.freeproduct_array ? JSON.parse(optionsData.freeproduct_array) : [];
          return FPCourses
        }
    },
    mounted(){
        if (Object.keys(this.priceData).length > 0 && window) {
        // TRACKING
        console.log('Product View', this.priceData.productName)
        // Set up data

        const testPaths = [
          "/courses/online/120-hour-premier-online-tefl-course/",
          "/courses/online/120-hour-premier-online-tefl-course-redesign/",
        ];

        const isTestPage = testPaths.includes(window.location.pathname);
        const abBucket = isTestPage ? getABBucket() : null;

        const data = {
            product_id: this.priceData.sku,
            sku: this.priceData.sku,
            name: this.priceData.productName,
            price: this.$nuxt.$options.filters.priceFromLabelNumber(this.priceData.pricesDiscounted),
            discount: this.$nuxt.$options.filters.priceFromLabelNumber(this.priceData.product.prices) === this.$nuxt.$options.filters.priceFromLabelNumber(this.priceData.pricesDiscounted) ? 0 : this.$nuxt.$options.filters.priceFromLabelNumber(this.priceData.product.prices) - this.$nuxt.$options.filters.priceFromLabelNumber(this.priceData.pricesDiscounted),
            coupon: this.priceData.offerCode,
            category: this.priceData.productType,
            currency: this.$nuxt.$options.filters.currencyCodeFromLabel(),
            quantity: 1,
        }
        const dataGTM = {
            item_id: this.priceData.sku,
            item_name: this.priceData.productName,
            price: this.$nuxt.$options.filters.priceFromLabelNumber(this.priceData.pricesDiscounted),
            discount: this.$nuxt.$options.filters.priceFromLabelNumber(this.priceData.product.prices) === this.$nuxt.$options.filters.priceFromLabelNumber(this.priceData.pricesDiscounted) ? 0 : this.$nuxt.$options.filters.priceFromLabelNumber(this.priceData.product.prices) - this.$nuxt.$options.filters.priceFromLabelNumber(this.priceData.pricesDiscounted),
            coupon: this.priceData.offerCode,
            quantity: 1,
            item_category: this.priceData.productType,
        }

        if (abBucket) data.ab_bucket = abBucket;
        if (abBucket) dataGTM.ab_bucket = abBucket;

        // For GTM
        const items = []
        items.push(dataGTM)



        // Track via rudderstack
        this.$rs.track("Product Viewed",
            data,
        )

        // Track via GTM
        this.$gtm.push({
            event: 'view_item',
            ecommerce: {
              currency: this.$nuxt.$options.filters.currencyCodeFromLabel(),
              value: this.$nuxt.$options.filters.priceFromLabelNumber(this.priceData.pricesDiscounted),
              items,
            }
        });

        if (abBucket) {
          this.$gtm.push({
            event: "experiment_viewed",
            experiment_id: "120_hour_pdp_test",
            variant: abBucket,
          });

          this.$rs.track("Experiment Viewed", {
            experiment_id: "120_hour_pdp_test",
            variant: abBucket,
          });
        }
        }
    },
    methods: {
        ...mapActions({
            addToCart:'cart/addToCartServer'
        }),
        limit(string, limit){
          return string.substring(0, limit)+"..."
        }
    }
}
